import React from 'react';
import {withStyles} from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';

const styles = theme => ({
  noMaxWidth: {
    maxWidth: 'none',
  },
});

export default withStyles(styles)(class extends React.Component {
  constructor (props) {
    super(props)
  }

  render() {
    const {classes} = this.props
    return <Tooltip disableTouchListener {...this.props} classes={{ tooltip: classes.noMaxWidth }}>
      {this.props.children}
    </Tooltip>
  }
})



// WEBPACK FOOTER //
// ./app/Components/Tooltip.js